import { styled } from 'styled-components'

import { color, fontSize, fontWeight, space } from './utils'

export const DebugFlag = styled.div`
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid white;
  border-right: none;
  border-top: none;
  color: white;
  padding: ${space(1)} ${space(2)};
  font-size: ${fontSize('xxSmall')};
  font-weight: ${fontWeight('bold')};
  position: fixed;
  right: 0;
  top: 0;
  pointer-events: none;
  text-transform: uppercase;
  z-index: 1001;
  &:before {
    background: ${color('primary')};
    border-radius: 50%;
    content: '';
    display: inline-block;
    height: 10px;
    margin-right: 5px;
    width: 10px;
  }
`
